import React from "react";

import { Chart as ChartJS } from "chart.js/auto";
import { Chart } from "react-chartjs-2";
import { Line, Bar } from "react-chartjs-2";

const grafico = (props) => {
  const _datos = props.datos;
  const _etiquetas = props.etiquetas;
  const _titulo = props.titulo;

  // Pattern of 4 colors that will repeat for all bars
  const colorPattern = [
    "rgba(145, 46, 51, 0.8)",
    "rgba(255, 86, 28, 0.8)",
    "rgba(255, 198, 27, 0.8)",
    "rgba(255, 150, 37, 0.8)",
  ];

  // Create background color array by cycling through the pattern
  const backgroundColors = _datos.map(
    (_, index) => colorPattern[index % colorPattern.length],
  );

  const data1 = {
    label: "Total",
    data: _datos,
    borderColor: "rgb(200, 200, 200)",
    backgroundColor: backgroundColors,
    pointBackgroundColor: "rgba(255, 99, 132, 0.5)",
    pointBorderColor: "rgb(255, 99, 132)",
    barPercentage: 0.5,
  };

  const _data = {
    labels: _etiquetas,
    datasets: [data1],
  };

  const _options = {
    indexAxis: "y",
    maintainAspectRatio: false,
    responsive: true,
    layout: {
      padding: {
        left: 0,
      },
    },
    scales: {
      x: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 10,
          font: {
            size: 10,
          },
        },
      },
      y: {
        ticks: {
          stepSize: 1,
          autoSkip: false,
          font: {
            size: 14,
          },
        },
        afterFit: function (scaleInstance) {
          scaleInstance.width = 180;
        },
        title: {
          display: true,
          text: _titulo,
          padding: { top: 0, bottom: 0 },
          font: { size: 24, style: "bold" },
        },
      },
    },
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            return context.parsed.x + "%";
          },
        },
      },
      legend: {
        display: false,
        position: "top",
      },
      title: {
        display: false,
        text: "Chart.js Line Chart",
      },
    },
  };

  return (
    <Bar
      options={_options}
      data={_data}
      style={{ height: "100%", width: "100%" }}
    ></Bar>
  );
};

const GraficoPregunta = (props) => {
  //console.log(props);
  return <div style={{ height: "100%", width: "100%" }}>{grafico(props)}</div>;
};

export default GraficoPregunta;
